<template>
	<div class="animated fadeIn" v-show="isActive">
		<slot></slot>
	</div>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'Tab',

		/*
		**  Set up the props
		*/

		props: {

	        name: { required: true },
	        selected: { default: false},
	        icon: {default: null},

	    },

	    /*
		**  Set up the data to be returned
		*/

	    data: () => ({

	      	isActive: false,
	        
	    }),

	    /*
		**  Assign the href to the corresponding tab ID
		*/

	    computed: {
        
	        href() {

	            return '#' + this.name.toLowerCase().replace(/ /g, '-');

	        }

	    },

	    /*
		**  Set the active tab
		*/

	    mounted() {
        
	        this.isActive = this.selected;
	        
	    }

	}

</script>